import { combineReducers } from 'redux'

import handbookReducer from './handbookReducer'
import clientAddReducer from './clientAddReducer'
import quickCalculationReducer from './quickCakculationReducer'
import dashboardReducer from './dashboardReducer'
import clientsReducer from './clientsReducer'
import contractReducer from './contractReducer'
import userReducer from './userReducer'
import searchReducer from './searchReducer'
import transactionsReducer from './transactionsReducer'
import kbExchangeReducer from './kbExchangeReducer'
import clientShortInfoReducer from './clientShortInfoReducer'
import notificationReducer from './notificationReducer'
import directoriesReducer from "./directoriesReducer";
import remotelyReportsReducer from "./remotelyReportsReducer";
import mcsIntegrationReducer from "./mcsIntegrationReducer";
import debtLoadReducer from './debtLoadReducer'
import autoLombardReducer from './autoLombardReducer'

const rootReducer = combineReducers({
  handbook: handbookReducer,
  clientAdd: clientAddReducer,
  quickCalculation: quickCalculationReducer,
  dashboard: dashboardReducer,
  clients: clientsReducer,
  contract: contractReducer,
  user: userReducer,
  search: searchReducer,
  transactions: transactionsReducer,
  kb: kbExchangeReducer,
  clientInfo: clientShortInfoReducer,
  notification: notificationReducer,
  directories: directoriesReducer,
  remotelyReports: remotelyReportsReducer,
  mcsIntegration: mcsIntegrationReducer,
  debtLoad: debtLoadReducer,
  autolombard: autoLombardReducer
})

export default rootReducer
